import Highcharts from 'highcharts';
Highcharts.setOptions({
	lang: {
		      decimalPoint: ','
	      }

});

export const figure41 = { 
chart: {
zoomType: 'xy',
animation: false,
marginTop: 40,
plotBackgroundColor: null,
plotBorderWidth: null,
plotShadow: false,
type: 'bar',
height:'400px',
backgroundColor: 'rgba(255, 255, 255, 0.0)',
style: {
fontFamily: 'Montserrat'
}
},

credits: {
enabled: false
},
title: {
text: null
},
subtitle: {
text: null
},

plotOptions: {
series: {
borderWidth: 0,
stacking: 'normal',
dataLabels: {
enabled: true,
formatter: function () {
// 'this.y' contains the data value of the point
return Highcharts.numberFormat(this.y,0) + ''; // Format the value as Pourcentage with 2 decimal places
},
},
},
},

exporting: {
enabled: false
},


xAxis: [{
categories: [ 
	     "Enregistrement conjoint des terres",
	     "Consentement du conjoint concernant les transactions foncières",
	     "Égalité des droits de succession pour les femmes et les filles",
	     "Ressources financières**",
	     "Protection par le droit coutumier*",
	     "Participation à la gouvernance foncière**", 
],
lineColor: "#d7d7d7",
tickColor: "#d7d7d7",
tickLength: 10,
labels: {
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px',
}
},
}],
yAxis: [{ // Primary yAxis
labels: {
//format: '{value}%',
enabled: false,		
style: {
fontWeight: 'normal',
color: '#999999',
fontSize: '12px'
},
},
gridLineWidth: 0,
floor: 0,
title: {
text: "",
style: {
color: Highcharts.getOptions().colors[1]
}
},
}],
tooltip: {
shared: true,
useHTML: true,
hideDelay: 500,
backgroundColor: null,
borderWidth: 0,
shadow: false,
//headerFormat: '<div>{point.key}</div>',
style: {
padding: 0
},
pointFormatter: function () {
// 'this.y' contains the data value of the point
return '<div><span style="color:' + this.color + '">\u25CF</span> ' + this.series.name + ': ' +
Highcharts.numberFormat(this.y, 0) + '%' + '</div>';
},
},
legend: {
enabled: false,
},

series: [
{
name: 'Pas présente',
valueSuffix: '%',
color: '#c00000',
marker: {
"symbol": 'square',
perc: '34%',
radius: 2
},	      
data: [ 66, 42, 42, 76, 49, 59 ]
},
{
name: 'Présente',
valueSuffix: '%',
color: '#5b9bd5',
marker: {
"symbol": 'square',
perc: '66%',
radius: 2
},	      		  
data: [ 34, 58, 58, 24, 51, 41 ]
},
]
}

